import service from "@/store/services/equipments-service";

export const state = () => ({
  list: {},
  equipment: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, equipment) => {
    state.equipment = equipment;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((equipment) => {
      commit("SET_RESOURCE", equipment);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((equipment) => {
      commit("SET_RESOURCE", equipment);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((equipment) => {
      commit("SET_RESOURCE", equipment);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
  print({ commit, dispatch }, params) {
    return service.print(params, this.$axios).then((response) => {
      return response;
    });
  },
  applyConfiguration({ commit, dispatch }, params) {
    return service.applyConfiguration(params, this.$axios).then((data) => {
      commit("SET_RESOURCE", data);
      return data;
    });
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  equipment: (state) => state.equipment,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((equipment) => ({
      id: equipment.id,
      name: `${equipment.name}`,
    }));
  },
};

const equipments = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default equipments;
